import { render, staticRenderFns } from "./480.vue?vue&type=template&id=32c17228&scoped=true&"
import script from "./480.vue?vue&type=script&lang=js&"
export * from "./480.vue?vue&type=script&lang=js&"
import style0 from "./480.vue?vue&type=style&index=0&id=32c17228&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c17228",
  null
  
)

export default component.exports